import React from 'react';
import DateRangePicker from '../../../element/daterangepicker';
import Title from '../../../element/title';
import url from '../../../urlhandler/urlHandlerActions';
import clone from 'clone';

class DateRangePickerPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'values': 'Demo Input',
      'options': [],
      'toogle': true,
    };
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.changeToogle = this.changeToogle.bind(this);
    this.handleDateRange = this.handleDateRange.bind(this);
  }
  componentWillMount() {
    this.block = this.props.block;
    const datepickertype = this.block.hasOwnProperty('selectedCalenderViewType') ? this.block.selectedCalenderViewType : 'single';
    this.setState({ datepickertype });
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
    const datepickertype = nextprops.block.hasOwnProperty('selectedCalenderViewType') ? nextprops.block.selectedCalenderViewType : 'single';
    this.setState({ datepickertype });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  handleDateRange(values) {
    if (this.block !== undefined) {
      if (this.block.selectedMetakey) {
        url.push({
          'searchItem': this.block.selectedMetakey,
          'searchType': 'metakeys',
          'searchField': 'daterange',
          values,
        });
      }
    }
    // this.setState({ values });
  }
  render() {
    // console.log(this.state.datepickertype);
    const allUrlData = window.searchArray;
    const defaultValue = {};
    allUrlData.map((item) => {
      const isDateRangeStart = item.key.indexOf('[start]');
      if (isDateRangeStart !== -1) {
        defaultValue.start = item.value;
      }
      const isDateRangeEnd = item.key.indexOf('[end]');
      if (isDateRangeEnd !== -1) {
        defaultValue.end = item.value;
      }
    });
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const HelperClass = this.state.toogle ? 'single-component' : '';
    const textBoxClassName = this.props.block.dynamicNameClassCheckBox;
    return (<div className={textBoxClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {this.props.block.selectedToogleViewType}
      />
      { this.state.toogle ? <div className={HelperClass}><DateRangePicker {...this.props} monthView={this.block.selectedMonthViewType !== undefined ? this.block.selectedMonthViewType : 'single'} default={defaultValue} dateFormat={this.block.dateFormat !== undefined ? this.block.dateFormat : 'MM-DD-YYYY' } datepickertype={this.state.datepickertype} grabDateRangeValue={this.handleDateRange} /></div> : null }
    </div>);
  }
}

DateRangePickerPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default DateRangePickerPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/default/daterangepickerpreview.js
 **/